import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import { assertSuppliersAvailableToDependent } from "../rbac/crossResourceAvailability";
import { uniqueWorkflowName } from "../workflowName";
import { mutator } from "./mutator";

export const recoverWorkflow = mutator({
  schema: z.object({ workflowId: z.string() }),
  resolve: {
    workflow: { kind: "deletedWorkflow", from: "workflowId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.workflow.spaceId,
    },
  ],
  fn: async ({ tx, args: { workflow } }) => {
    const mappings = await tx.run(
      zql.connectedAppUsages
        .where("type", "workflow_slug")
        .where("refId", workflow.id)
        .related("connectedApp")
    );
    await assertSuppliersAvailableToDependent(
      tx,
      workflow.tenantId,
      "space_uses_connected_apps",
      workflow.spaceId,
      mappings.map((m) => ({
        id: m.connectedAppId,
        label: m.connectedApp!.name,
      })),
      "recover workflow"
    );

    // A workflow with this name may have been created while this one was
    // deleted, so de-duplicate against the live workflows before restoring it.
    const active = await tx.run(
      zql.workflows
        .where("spaceId", workflow.spaceId)
        .where("deletedAt", "IS", null)
    );
    const name = uniqueWorkflowName(
      workflow.name,
      active.map((w) => w.name)
    );

    await tx.mutate.workflows.update({
      id: workflow.id,
      deletedAt: null,
      name,
    });
  },
});
